import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';

// Guards
import { AuthenticationGuard } from './core/guards/authentication/authentication.guard';
import { CheckOfflineFilesGuard } from './core/guards/check-offline-files/check-offline-files.guard';
import { CheckActivationCodeGuard } from './core/guards/check-activation-code/check-activation-code.guard';
import { ConfigFileGuard } from './core/guards/config-file/config-file.guard';
import { ConnectionGuard } from './core/guards/connection/connection.guard';
import { PwaGuard } from './core/guards/pwa/pwa.guard';
import { RouteGuard } from './core/guards/route/route.guard';

const routes: Routes = [
  {
    path: 'splash',
    loadChildren: () => import('./modules/splash/splash.module').then((m) => m.SplashModule),
    canActivate: [RouteGuard],
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
    canActivate: [
      ConnectionGuard,
      RouteGuard,
      CheckActivationCodeGuard,
      ConfigFileGuard,
      AuthenticationGuard,
      CheckOfflineFilesGuard,
    ],
  },
  {
    path: 'information',
    loadChildren: () => import('./modules/information/information.module').then((m) => m.InformationModule),
    canActivate: [RouteGuard],
  },
  {
    path: 'play/:MODE',
    loadChildren: () => import('./modules/play/play.module').then((m) => m.PlayModule),
    canActivate: [],
  },
  {
    path: 'settings',
    loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [RouteGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

if (environment.production) {
  routes.forEach((route) => {
    if (route.path !== '') {
      route.canActivate.push(PwaGuard);
    }
  });
}

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
